import { DialogBody, DialogCloseTrigger, DialogContent, DialogHeader, DialogRoot } from '@/components/ui/dialog';
import { Heading, HStack, Separator, Text, VStack } from '@chakra-ui/react';

export const RaffleFaqModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  return (
    <DialogRoot open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogCloseTrigger />
        <DialogHeader flexDir="column">
          <Heading size="4xl" fontWeight="700">
            Raffle FAQ
          </Heading>
        </DialogHeader>
        <DialogBody>
          <VStack alignItems="stretch" gap={4}>
            <FAQCard
              title="How are prizes delivered?"
              description="Delivery depends on your location and logistics. If shipping the physical item isn’t feasible, we’ll send the stablecoin equivalent directly to your wallet."
            />
            <Separator />
            <FAQCard
              title="What if I don’t want the physical prize?"
              description="No problem! You can choose to receive the stablecoin equivalent of the prize value instead of the physical item."
            />
            <Separator />
            <FAQCard
              title="Do I need to provide personal details?"
              description="Providing your address is optional. If you prefer, you can receive only the stablecoin equivalent and just share your wallet address—no need to provide personal info."
            />
            <Separator />
            <FAQCard
              title="What about taxes on winnings?"
              description="We can't provide tax advice. Please handle any tax obligations according to your local laws."
            />
          </VStack>
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
};

const FAQCard = ({ title, description }: { title: string; description: string }) => (
  <HStack justifyContent="space-between">
    <VStack alignItems="start" gap={2}>
      <Heading size="lg" fontWeight="500">
        {title}
      </Heading>
      <Text color="fg.muted" fontWeight="500" fontSize="md" letterSpacing="-0.18px">
        {description}
      </Text>
    </VStack>
  </HStack>
);
